import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, ArrowUpRight, Sparkles, Truck, Tag } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function SupplyStoreBanner() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <Sparkles className="w-4 h-4" data-id="element-331" />,
    text: t('supply.f1')
  }, {
    icon: <Tag className="w-4 h-4" data-id="element-332" />,
    text: t('supply.f2')
  }, {
    icon: <Truck className="w-4 h-4" data-id="element-333" />,
    text: t('supply.f3')
  }];
  return <section className="py-16 lg:py-20 bg-brand-black relative overflow-hidden" data-id="element-334">
      {/* Background gold accent */}
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-335" />
      <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-336" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-337">
        <motion.a href="https://www.jomelitesupply.com/" target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="group block bg-brand-dark border-2 border-brand-gold/30 hover:border-brand-gold rounded-3xl p-8 md:p-12 lg:p-16 relative overflow-hidden transition-all duration-500 hover:shadow-[0_20px_60px_rgba(212,164,55,0.2)]" data-id="element-338">
          {/* Decorative pattern */}
          <div className="absolute top-0 right-0 w-1/2 h-full opacity-5 pointer-events-none" data-id="element-339">
            <ShoppingBag className="w-full h-full text-brand-gold" strokeWidth={1} data-id="element-340" />
          </div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-341">
            {/* Left content */}
            <div className="lg:col-span-8" data-id="element-342">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-gold/15 border border-brand-gold/30 text-brand-gold text-xs font-bold tracking-widest uppercase mb-6" data-id="element-343">
                <ShoppingBag className="w-3.5 h-3.5" data-id="element-344" />
                <span data-id="element-345">{t('supply.badge')}</span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-4 text-balance" data-id="element-346">
                {t('supply.title1')}
                <span className="text-brand-gold" data-id="element-347">{t('supply.title2')}</span>?
              </h2>

              <p className="text-lg text-white/70 mb-8 max-w-2xl leading-relaxed" data-id="element-348">
                {t('supply.desc')}
              </p>

              {/* Feature pills */}
              <div className="flex flex-wrap gap-3 mb-8" data-id="element-349">
                {features.map((feature, i) => <div key={i} className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-full text-sm text-white/80" data-id="element-350">
                    <span className="text-brand-gold" data-id="element-351">{feature.icon}</span>
                    <span className="font-medium" data-id="element-352">{feature.text}</span>
                  </div>)}
              </div>

              {/* URL display */}
              <div className="flex items-center gap-3 text-brand-gold font-mono text-sm md:text-base" data-id="element-353">
                <span className="opacity-50" data-id="element-354">→</span>
                <span className="font-semibold tracking-wide" data-id="element-355">
                  www.jomelitesupply.com
                </span>
              </div>
            </div>

            {/* Right CTA */}
            <div className="lg:col-span-4 flex lg:justify-end" data-id="element-356">
              <div className="flex items-center gap-4 bg-brand-gold text-brand-black px-8 py-5 rounded-xl font-bold text-lg shadow-lg group-hover:bg-brand-goldLight transition-all duration-300 group-hover:scale-105 w-full lg:w-auto justify-center" data-id="element-357">
                <span data-id="element-358">{t('supply.cta')}</span>
                <ArrowUpRight className="w-6 h-6 transition-transform duration-300 group-hover:rotate-45" strokeWidth={2.5} data-id="element-359" />
              </div>
            </div>
          </div>
        </motion.a>
      </div>
    </section>;
}